// import React from "react";
// import { Link } from "react-router-dom";

// export const Contact = (props) => {
  
//   return (
//     <div>
//       <div id="contact">
//         <div className="container">
//           <div className="col-md-12">
//             <div className="row">
//               <div className="section-title">
//               </div>
//               <div className="row">
//                 <div className="col-md-3 col-xs-12">
//                   <h5>{props.data ? props.data.nameBank2 : "Banco não definido"}</h5>
//                 {/* <div className="contact-item">
//                   <p> CNPJ {props.data ? props.data.line1.cnpj : "loading"} </p>
//                 </div> */}
//                 <div className="contact-item">
//                   {/* <p>{props.data ? props.data.line1.address : "loading"} / {props.data ? props.data.line1.complemento : "loading"}</p> */}
//                    <p>{props.data ? props.data.line1.address : "loading"}</p>
//                     <p>{props.data ? props.data.line1.bairro : "loading"}{" "}</p>
//                 </div>
               
//                 <div className="contact-item">
//                   <p>{props.data ? props.data.line1.city : "loading"}{" "} </p>
//                 </div>
//                 <div className="contact-item">
//                   <p>CEP {props.data ? props.data.line1.cep : "loading"}{" "} </p>
//                 </div>
//                 </div>

//                 <div className="col-md-2 col-xs-12">
//                   <h5>Quem Somos</h5>
//                   <div className="contact-item">
//                     <a href={props.data ? props.data.about.link1 : '/'}> {props.data ? props.data.about.title1 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <Link to={props.data ? props.data.about.link2 : '/'}> {props.data ? props.data.about.title2 : "loading"} </Link>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.about.link3 : '/'}> {props.data ? props.data.about.title3 : "loading"} </a>
//                   </div>
//                 </div>

//                 <div className="col-md-2 col-xs-12">
//                   <h5>Produtos</h5>
//                   <div className="contact-item">
//                     <a href={props.data ? props.data.products.link1 : '/'}> {props.data ? props.data.products.title1 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.products.link2 : '/'}> {props.data ? props.data.products.title2 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.products.link3 : '/'}> {props.data ? props.data.products.title3 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.products.link4 : '/'}> {props.data ? props.data.products.title4 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.products.link5 : '/'}> {props.data ? props.data.products.title5 : "loading"} </a>
//                   </div>
//                 </div>

//                 <div className="col-md-2 col-xs-12">
//                   <h5>LGPD</h5>
//                   <div className="contact-item">
//                     <a href={props.data ? props.data.lgpd.link1 : '/'}> {props.data ? props.data.lgpd.title1 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.lgpd.link2 : '/'}> {props.data ? props.data.lgpd.title2 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.lgpd.link3 : '/'}> {props.data ? props.data.lgpd.title3 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.lgpd.link4 : '/'}> {props.data ? props.data.lgpd.title4 : "loading"} </a>
//                   </div>
//                   <div className="contact-item">
//                   <a href={props.data ? props.data.lgpd.link5 : '/'}> {props.data ? props.data.lgpd.title5 : "loading"} </a>
//                   </div>
//                 </div>

//                 <div className="col-md-3 col-xs-12">
//                   <h5>Fale com a gente</h5>
//                   <div className="contact-item">
//                     <p>
//                       <i className="fa fa-envelope"> </i>{props.data ? props.data.email : "loading"}
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               {/* <div className="col-md-4 lei">
//                 <p>A {props.data ? props.data.nameBank : "Banco não definido"} não realiza qualquer atividade privativa de instituições financeiras, direto a seus clientes. Nos termos da Resolução nº 4.935, de 29 de julho de 2021, do Conselho Monetário Nacional, a {props.data ? props.data.nameBank : "Banco não definido"} CNPJ: {props.data ? props.data.line1.cnpj : "CNPJ não definido"}, atua meramente como Parceiro Bancário de instituições financeiras, as quais, na qualidade de agentes bancarizadores devidamente autorizados pelo Banco Central do Brasil, A instituição financeira com a qual atuamos é Delcred Sociedade de Crédito Direto S/A - CNPJ: 38.224.857/0001-68 - Empresa do Sistema Financeiro Nacional nº 435.</p>
//               </div> */}
//               <div className="col-md-12">
//                   <div className="row">
//                     <div className="social">
//                       <ul>
//                         <li>
//                           <a href={props.data ? props.data.facebook : "/"}>
//                             <i className="fa fa-facebook"></i>
//                           </a>
//                         </li>
//                         <li>
//                           <a href={props.data ? props.data.linkedin : "/"}>
//                             <i className="fa fa-linkedin"></i>
//                           </a>
//                         </li>
//                         <li>
//                           <a href={props.data ? props.data.insatgram : "/"}>
//                             <i className="fa fa-instagram"></i>
//                           </a>
//                         </li>
//                         <li>
//                           <a href={props.data ? props.data.whatsapp : "/"}>
//                             <i className="fa fa-whatsapp"></i>
//                           </a>
//                         </li>
//                       </ul>
//                   </div>
//                 </div>
               
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
      
//       <div id="footer">
//         <div className="container text-center">
//           <p>
//             &copy; {props.data ? props.data.nameBank2 : "/"} - Todos os direitos reservados.{" "}
//           </p>
//           {/* <p>{props.data ? props.data.line1.cnpj : "/"} </p> */}
//         </div>
//       </div>
//     </div>
//   );
// };


import React, { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { navigateToSection, parseHashSectionHref } from "../utils/hashSectionNav";

export const Contact = (props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onFooterAnchor = (e, href) => {
    const id = parseHashSectionHref(href);
    if (!id) return;
    e.preventDefault();
    navigateToSection(navigate, location, id);
  };

  // IntersectionObserver para animação
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: '0px', threshold: 0 }
    );

    const elements = document.querySelectorAll("#contact .reveal");
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <div className="section-title reveal">
              </div>
              <div className="row">
                <div className="col-md-3 col-xs-12 reveal">
                  <h5>{props.data ? props.data.nameBank2 : "Banco não definido"}</h5>
                  {props.data?.line1?.cnpj ? (
                    <div className="contact-item">
                      <p>CNPJ {props.data.line1.cnpj}</p>
                    </div>
                  ) : null}
                  {(props.data?.line1?.address || props.data?.line1?.bairro) ? (
                    <div className="contact-item">
                      {props.data?.line1?.address ? <p>{props.data.line1.address}</p> : null}
                      {props.data?.line1?.bairro ? <p>{props.data.line1.bairro}</p> : null}
                    </div>
                  ) : null}
                  {props.data?.line1?.city ? (
                    <div className="contact-item">
                      <p>{props.data.line1.city}</p>
                    </div>
                  ) : null}
                  {props.data?.line1?.cep ? (
                    <div className="contact-item">
                      <p>CEP {props.data.line1.cep}</p>
                    </div>
                  ) : null}
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>Quem Somos</h5>
                  <div className="contact-item">
                    <a
                      href={props.data ? props.data.about.link1 : "/"}
                      onClick={(e) =>
                        onFooterAnchor(e, props.data ? props.data.about.link1 : "")
                      }
                    >
                      {props.data ? props.data.about.title1 : "loading"}
                    </a>
                  </div>
                  <div className="contact-item">
                    <Link to={props.data ? props.data.about.link2 : '/'}>{props.data ? props.data.about.title2 : "loading"}</Link>
                  </div>
                  <div className="contact-item">
                    <Link to={props.data ? props.data.about.link3 : "/"}>
                      {props.data ? props.data.about.title3 : "loading"}
                    </Link>
                  </div>
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>Produtos</h5>
                  {props.data &&
                    Object.keys(props.data.products)
                      .filter((key) => key.startsWith("title"))
                      .sort()
                      .map((key) => {
                        const suffix = key.replace("title", "");
                        return (
                          <div key={key} className="contact-item">
                            <a href={props.data.products[`link${suffix}`]}>
                              {props.data.products[key]}
                            </a>
                          </div>
                        );
                      })}
                </div>

                <div className="col-md-2 col-xs-12 reveal">
                  <h5>LGPD</h5>
                  {props.data && Array.from({ length: 5 }, (_, i) => (
                    <div key={i} className="contact-item">
                      <a href={props.data.lgpd[`link${i+1}`]}>
                        {props.data.lgpd[`title${i+1}`]}
                      </a>
                    </div>
                  ))}
                </div>

                <div className="col-md-3 col-xs-12 reveal">
                  <h5>Fale com a gente</h5>
                  <div className="contact-item">
                    <p><i className="fa fa-envelope"></i>{props.data ? props.data.email : "loading"}</p>
                  </div>
                </div>
              </div>

              <div className="col-md-12 reveal">
                <div className="row social">
                  <ul>
                    <li><a href={props.data ? props.data.facebook : "/"}><i className="fa fa-facebook"></i></a></li>
                    <li><a href={props.data ? props.data.linkedin : "/"}><i className="fa fa-linkedin"></i></a></li>
                    <li><a href={props.data ? props.data.instagram : "/"}><i className="fa fa-instagram"></i></a></li>
                    <li><a href={props.data ? props.data.whatsapp : "/"}><i className="fa fa-whatsapp"></i></a></li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      
      <div id="footer">
        <div className="container text-center">
          <p>&copy; {props.data ? props.data.nameBank2 : "/"} - Todos os direitos reservados.</p>
          {props.data?.line1?.cnpj ? <p>{props.data.line1.cnpj}</p> : null}
        </div>
      </div>
    </div>
  );
};
